import { useTranslation } from 'react-i18next';
import { Box, Flex } from 'reflexbox';
import moment from 'moment';
import { Avatar, Heading, Paragraph, PlainCard, Skeleton } from '@treams/treams-ui';
import { Link } from 'react-router-dom';

import * as graphql from 'generated/graphql';

import useAuthenticatedUser from '../packages/kakapo-ui-application/hooks/useAuthenticatedUser';

export default Skeleton(
	function IncomingComplimentCard(props: { compliment: graphql.Compliment; userID: string }) {
		const viewer = useAuthenticatedUser();
		const { t } = useTranslation();

		return (
			<PlainCard
				to={
					viewer.id === props.userID
						? `/feedback/compliments/${props.compliment.id}`
						: `/users/${props.userID}/feedback/compliments/${props.compliment.id}`
				}
			>
				<Flex alignItems="center">
					<Box py={3} flexGrow={1} flexShrink={1}>
						<Paragraph>
							{t('feedback.compliments.card.from')}
							&nbsp;
							<Link to={`/user/${props.compliment.sender.id}`}>
								{[props.compliment.sender.firstName, props.compliment.sender.lastName].join(' ')}
							</Link>
							{' · '}
							{t('feedback.compliments.card.receivedAt', {
								date: moment(props.compliment.createdAt).format('LL'),
							})}
						</Paragraph>
						<Heading mt={2}>
							{t('feedback.compliments.card.title', {
								sender: [props.compliment.sender.firstName, props.compliment.sender.lastName].join(
									' ',
								),
							})}
						</Heading>
					</Box>
					<Flex flexGrow={0} flexShrink={0}>
						<Box mr={2}>
							<Avatar size={32} user={props.compliment.sender} />
						</Box>
					</Flex>
				</Flex>
			</PlainCard>
		);
	},
	function IncomingComplimentCardSkeleton() {
		return (
			<PlainCard.Skeleton>
				<Flex alignItems="center">
					<Box py={3} flexGrow={1} flexShrink={1}>
						<Paragraph.Skeleton lines={1} />
						<Heading.Skeleton mt={2} />
					</Box>
					<Flex flexGrow={0} flexShrink={0}>
						<Box mr={2}>
							<Avatar.Skeleton size={32} />
						</Box>
					</Flex>
				</Flex>
			</PlainCard.Skeleton>
		);
	},
);
